export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s.length <= 10 ? `${s}T12:00:00` : s);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const STATUS_LABELS = {
  paid: "Paid",
  pending: "Pending",
  refunded: "Refunded",
  partially_refunded: "Partly refunded",
  cancelled: "Cancelled",
};

export const STATUS_STYLES = {
  paid: "bg-primary/10 text-primary",
  pending: "bg-amber-100 text-amber-800",
  refunded: "bg-destructive/10 text-destructive",
  partially_refunded: "bg-orange-100 text-orange-800",
  cancelled: "bg-muted text-muted-foreground line-through",
};

export const PLATFORMS = ["Shopify", "PayPal", "Venmo", "Cash App", "Skool", "Manual Entry", "Other"];
